import { buildBranchAdminUrl } from "@/shared/lib/branch/branch-admin-routing"

/**
 * The tabs of one reconciliation session.
 *
 * Each is a real URL segment (`/finance/reconciliation/:id/history`), per the repo rule that a tabbed page
 * must be deep-linkable — which matters more here than usual: a review notification links a reviewer straight
 * to a session, and "look at the history" has to be a link somebody can send.
 */
export enum ReconciliationDetailTab {
  /** The period's transactions, ticked off against the statement. */
  Transactions = "transactions",
  /** The statement the claim was prepared against. */
  Statement = "statement",
  /** Who did what, when, and what they said about it. */
  History = "history",
}

export const RECONCILIATION_DETAIL_TABS: readonly ReconciliationDetailTab[] = [
  ReconciliationDetailTab.Transactions,
  ReconciliationDetailTab.Statement,
  ReconciliationDetailTab.History,
]

/** The active tab from a pathname; falls back to Transactions, which is where the work happens. */
export function parseReconciliationDetailTabFromPathname(pathname: string): ReconciliationDetailTab {
  const match = pathname.match(/\/finance\/reconciliation\/[^/]+\/([^/?#]+)/)
  const segment = match?.[1]
  for (const tab of RECONCILIATION_DETAIL_TABS) {
    if (segment === tab) return tab
  }
  return ReconciliationDetailTab.Transactions
}

export function buildReconciliationDetailTabHref(
  branchSlug: string,
  sessionId: string,
  tab: ReconciliationDetailTab,
  workspaceSlug?: string,
): string {
  return buildBranchAdminUrl(branchSlug, `/finance/reconciliation/${sessionId}/${tab}`, workspaceSlug)
}
